import axios from "axios";
import React, { createContext, useState } from "react";
import { useHistory } from "react-router";
import { message } from "antd";
import Cookies from "js-cookie";

export const UserGames = createContext()

export const UsersProvider = props => {

    let history = useHistory () 
    const [dataGame, setDataGame] = useState([])


    const [fetchStatus, setFetchStatus] = useState(true)
    const [input, setInput] = useState({
        name:"",
        genre: "",
        singlePlayer: 1,
        multiplayer: 1,
        platform:"",
        release:0,
        image_url:""
    })
    const [currentId, setCurrentId] = useState(null)

    const getGame = async () => {
        try{
        let res = await axios.get('https://backendexample.sanbersy.com/api/data-game')
       let result = res.data
       setDataGame([...result])
    }catch (error) {
        console.log(error)
    }
    }
    const info = () => {
        message.info('Data Terhapus');
      }
   
    const handleDelete = async (event) => {
        let dataId = parseInt(event.currentTarget.value)
       await  axios.delete(`https://backendexample.sanbercloud.com/api/data-game/${dataId}` , {headers: {"Authorization" : "Bearer "+ Cookies.get('token')}})
            setFetchStatus(true)
            info()
    }
    
   
    
    const handleEdit = async (event) => { 
        let dataId = parseInt(event.currentTarget.value)
        history.push(`/create-data-games/edit/${dataId}`)
    }

    const getDataById = async (Id) => {
    let result = await axios.get(`https://backendexample.sanbercloud.com/api/data-game/${Id}`)
    
        setInput({name : result.data.name, genre : result.data.genre, singlePlayer: result.data.singlePlayer, multiplayer: result.data.multiplayer, platform: result.data.platform, release: result.data.release, image_url: result.data.image_url})
        setCurrentId (result.data.id)

    }
    
    

const handleChange = (event) => {
    let typeOfName = event.target.name
    let value = event.target.value

    let player = ["singlePlayer", "multiplayer"]

    if (player.indexOf(typeOfName) === -1) {
        setInput({...input, [typeOfName]: value})
    } else {
        setInput({...input, [typeOfName]: !input[typeOfName]})
    }

}


const infoss = () => {
    message.info('Data Telah Ditambahkan!');
  }

const postData = async ({name, genre, singlePlayer, multiplayer, platform, release, image_url}) => {
    try {let result = await axios.post('https://backendexample.sanbercloud.com/api/data-game', {name: input.name, genre: input.genre, singlePlayer: input.singlePlayer, multiplayer: input.multiplayer, platform: input.platform, release : input.release, image_url: input.image_url}, {headers: {"Authorization" : "Bearer "+ Cookies.get('token')}} )
    setFetchStatus(true)
    console.log(input)
    history.push("/data-games")
    infoss()
}catch (err) {
    console.log(err) 
}
}

const infos = () => {
    message.info('Data Telah Diubah!');
  }

const replaceData = async ({name, genre, singlePlayer, multiplayer, platform, release, image_url}) => {
    try {let result = await axios.put(`https://backendexample.sanbercloud.com/api/data-game/${currentId}`, {name: input.name, genre: input.genre, singlePlayer: input.singlePlayer, multiplayer: input.multiplayer, platform: input.platform, release : input.release, image_url: input.image_url}, {headers: {"Authorization" : "Bearer "+ Cookies.get('token')}})
    setFetchStatus(true)
    history.push("/data-games")
    infos()
}catch (err) {
    console.log(err) }
}

const handleSubmit = (event) => {
    event.preventDefault()
    
    if (currentId === null) {
    
    postData(input)} 

    else {replaceData(input)}

    console.log(input)

    setInput ({
        name:"",
        genre: "",
        singlePlayer: 1,
        multiplayer: 1,
        platform:"",
        release:0,
        image_url:""
})

setCurrentId(null)
}

    let functions = {getDataById, getGame, handleDelete, handleEdit, handleChange, handleSubmit}
    
    return (
        <UserGames.Provider value={{dataGame, setDataGame, input, setInput, currentId, setCurrentId, fetchStatus, setFetchStatus, functions}}>
            {props.children}
        </UserGames.Provider>
    )
}